import { analyticsLogEvent } from '@src/utils/analytics';

export const assetDetailAnalyticsEvents = {
  eventClickAuPointMarketMeisai: () => analyticsLogEvent({ category: '【click】Pontaポイント(au PAYマーケット限定)', action: '残高>' }),
  eventClickAuMarkMeisai: () => analyticsLogEvent({ category: '【click】au PAYマーケット', action: 'ご利用額>' }),
  eventClickAuStockBtns: (btnName: string) => analyticsLogEvent({ category: '【click】auカブコム証券', action: btnName }),
  eventClickBundle: (category: string, action: string) => analyticsLogEvent({ category, action }),
  eventVisibleBundle: (category: string, action: string) => analyticsLogEvent({ category, action })
};
